import React, { useEffect, useState } from 'react';
import { array, bool, func } from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import clsx from 'clsx';

import queryString from 'query-string';

import { cloneDeep, isEmpty, isNil } from 'lodash';

import moment from 'moment';
import { getTimeZoneAbbr } from '../../../helpers/timezones';

import BobLoadingMask from '../../../components/BobLoadingMask';
import NoSelectedSensorsScreen from '../../../components/NoSelectedSensorsScreen';
import {
    Chart,
    ChartLegend,
    ChartSeries,
    ChartSeriesItem,
    ChartValueAxis,
    ChartValueAxisItem,
    ChartCategoryAxis,
    ChartCategoryAxisItem,
    ChartTooltip,
    ChartTitle,
    ChartPanes,
    ChartPane
} from '@progress/kendo-react-charts';

import {Grid, GridNoRecords, GridColumn as Column, GridToolbar} from '@progress/kendo-react-grid';

import { process as kendoProcess } from '@progress/kendo-data-query';
import FilterPanel from '../../../components/K2AFilterControl/FilterPanel';

import * as BobActions from '../../../actions/bobActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import * as ConfigurationActions from '../../../actions/configurationActions';
import { kendoGridInlineStyling } from '../../../helpers/kendoGridInlineStyleHelper';
import classes from './ScoresPanel.module.css';

const resolution2560 = matchMedia('(min-width:2560px)');
const resolution1920 = matchMedia('(min-width:1920px)');
const zoomLevel100 = matchMedia('(min-resolution: 1dppx)');
const zoomLevel125 = matchMedia('(min-resolution: 1.25dppx)');

const initialDataStateFilter = {
    logic:   'and',
    filters: []
};

const ScoresPanel = ({
    activeConfiguration,
    activeNavSite,
    axes,
    bobLoading,
    clearEntityScoresData,
    clearEntitySensorData,
    configuration,
    dashboardEndTimeStamp,
    dashboardStartTimeStamp,
    desiredInterval,
    entityScoringData,
    entityScoresData,
    fetchEntitySensorData,
    fetchScoringData,
    fetchSensorIds,
    gridDataState,
    gridFilter,
    gridFilterText,
    gridFields,
    history,
    isActive,
    rawUnits,
    ruleScoringConfig,
    ruleScoreKpis,
    selectedRule,
    selectedWeatherSensors,
    setActiveConfiguration,
    setConfiguration,
    setGridDataState,
    setGridFilter,
    setGridFilterText,
    setGridFields,
    setRuleScoringConfiguration,
    setSelectedRule,
    setSelectedRuleSensors,
    setSelectedWeatherSensors,
    allSensors,
    workbookModeEnabled,
    ...props
}) => {
    const [scores, setScores] = useState([]);
    const [numericSensors, setNumericSensors] = useState([]);
    const [ganttDs, setGanttDs] = useState([]);
    const [ganttAxisMax, setGanttAxisMax] = useState(0);
    const [ganttAxisMin, setGanttAxisMin] = useState(0);
    const [booleanDataSet, setBooleanDataSet] = useState([]);
    const [scoreGraphHeight, setScoreGraphHeight] = useState('58vh');
    const chart = React.createRef();

    const queryValues = queryString.parse(history.location.search);

    useEffect(() => {
        setGridDataState({...gridDataState, filter: initialDataStateFilter});
        setGridFilterText('');
    }, [workbookModeEnabled]);

    useEffect(() => {
        const { viewData } = activeConfiguration;
        if (!isEmpty(viewData)) {
            if (!isEmpty(viewData.selectedRule)) {
                setSelectedRule(viewData.selectedRule);
            }

            if (!isEmpty(viewData.selectedSensors)) {
                setSelectedRuleSensors(viewData.selectedSensors);
            }
        }
    }, [activeConfiguration.viewData]);

    const update2560TableHeight = () => {
        setScoreGraphHeight('69vh');
    };

    const update1920TableHeight = () => {
        if (window.innerWidth <= 1920 && window.devicePixelRatio === 1) {
            setScoreGraphHeight('58vh');
        }
        else if (window.innerWidth <= 1920 && window.devicePixelRatio > 1) {
            setScoreGraphHeight('48vh');
        }
        else {
            setScoreGraphHeight('69vh');
        }
    };

    const getChartInstance = () => {
        return chart;
    };

    props.propsFunc.getChartInstance = getChartInstance;

    useEffect(() => {
        return () => {
            resolution2560.removeEventListener('change', update2560TableHeight);
            resolution1920.removeEventListener('change', update1920TableHeight);
            zoomLevel100.removeEventListener('change', update1920TableHeight);
            zoomLevel125.removeEventListener('change', update1920TableHeight);
        };
    }, []);

    useEffect(() => {
        resolution2560.addEventListener('change', update2560TableHeight);
        resolution1920.addEventListener('change', update1920TableHeight);
        zoomLevel100.addEventListener('change', update1920TableHeight);
        zoomLevel125.addEventListener('change', update1920TableHeight);
        update1920TableHeight();
    }, []);


    useEffect(() => {
        let data = [];
        let sensorData = [];
        let entityScoringDataCopy = cloneDeep(entityScoringData);
        let scoreData =[], numericData = [], booleans =[];
        if (!isEmpty(entityScoringDataCopy)) {
            Object.keys(entityScoringDataCopy[0]).forEach(item => {
                let id = item.split('_');
                id = id[1];
                if (item.includes('Name') && (item.includes('rule') && !item.includes('ruleFvoSensor'))) {
                    Object.keys(entityScoringDataCopy[0]).forEach(point => {
                        if (point.includes(id) && point.includes('Val')) {
                            data.push({
                                name: entityScoringDataCopy[0][item],
                                key:  point,
                                axis: 'Left Y Axis',
                                data: []
                            });
                        }
                    });
                }
                if (
                    (item.includes('Name') && !item.includes('sensorParentName') && !item.includes('ruleName'))
                    && (item.includes('sensor') || item.includes('FvoSensor'))) {
                    Object.keys(entityScoringDataCopy[0]).forEach(point => {
                        const presentationUnitId = entityScoringDataCopy[0][`sensorPresentationUnitId_${id}`];
                        if (point === `sensorVal_${id}` || point === `ruleFvoSensorVal_${id}`) {
                            let obj = {
                                name:      entityScoringDataCopy[0][item],
                                key:       point,
                                axis:      'Left Y Axis',
                                data:      [],
                                unit:      presentationUnitId,
                                isWeather: false
                            };

                            if (point.includes('temp')) {
                                obj.unit = '°F';
                                obj.isWeather = true;
                            } else if (point.includes('humidity')) {
                                obj.unit = '%';
                                obj.isWeather = true;
                            } else if (point.includes('pressure')) {
                                obj.unit = ' hPa';
                                obj.isWeather = true;
                            } else {
                                obj.unit = presentationUnitId;
                            }
                            sensorData.push(obj);
                        }
                    });
                }

                if (item.includes('overallScore')) {
                    data.unshift({
                        name: 'Overall Score',
                        key:  item,
                        axis: 'Left Y Axis',
                        data: []
                    });
                }
            });

            data.forEach(item => {
                entityScoringDataCopy.forEach(score => {
                    let entry = {
                        timestamp: new Date(score['start']),
                        value:     !isNil(score[item.key]) ? renderValue(score, item) : null
                    };
                    item.data.push(entry);
                });
                scoreData.push(item);
            });

            sensorData.forEach(item => {
                entityScoringDataCopy.forEach(score => {
                    let entry = {
                        timestamp:      new Date(score['start']),
                        sampleInterval: desiredInterval?desiredInterval:15,
                        value:          !isNil(score[item.key]) ? renderValue(score, item) : null,
                        convertedValue: !isNil(score[item.key]) ? renderValue(score, item) : null
                    };
                    item.data.push(entry);
                });
                if (item.data.length > 0 && typeof (item.data[0].value) === 'boolean') {
                    booleans.push(item);
                } else {
                    numericData.push(item);
                }
            });
        }
        setScores(scoreData);
        setNumericSensors(numericData);
        processGanttDataset(booleans);

    }, [entityScoringData]);

    const getGanttSeries = (c, i) => {
        return {
            sensorId:   c.sensorId,
            sensorName: c.sensorName,
            axis:       'yAxis',
            dataColor:  i % 2 === 0 ? '#ff6d01' : '#6f6f6f',
            data:       []
        };
    };

    const labelContent = (e) => {
        if (e.value !== 0 && e.value - 1 < booleanDataSet.length) {
            return booleanDataSet[e.value - 1].name;
        }
        return '';
    };

    const processGanttDataset = (booleanDataSet) =>{
        let ganttDs = [];
        let ganttAxisMin = 0;
        let ganttAxisMax = 0;
        ganttAxisMax = booleanDataSet.length + 1;
        //Creating the gaps for plotting Gantt chart in bottom pane for boolean dataset
        booleanDataSet.forEach((bdata, i) => {
            bdata.data = bdata.data.sort(function (a, b) {
                return a.timestamp - b.timestamp;
            });

            let ganttSeries = getGanttSeries(bdata, i);
            ganttSeries.sensorId = bdata.key;
            ganttSeries.sensorName = bdata.name;
            let lastval = bdata.data[0].timestamp.getTime();
            bdata.data.forEach((data, j) => {
                if (lastval !== data.timestamp.getTime()) {
                    if (ganttSeries.data.length >0 && ganttSeries.data[ganttSeries.data.length - 1].booleanValue !== data.convertedValue) {
                        ganttDs.push(ganttSeries);
                        let lastpoint = {...ganttSeries.data[ganttSeries.data.length - 1]};
                        lastpoint.booleanValue = data.convertedValue;
                        // lastpoint.value = data.convertedValue;
                        ganttSeries = getGanttSeries(bdata, i);
                        ganttSeries.sensorId = bdata.key;
                        ganttSeries.sensorName = bdata.name;
                        ganttSeries.data.push(lastpoint);
                    }
                    data.booleanValue = data.convertedValue;

                    if (isNil(data.convertedValue)) {
                        ganttSeries.dataColor = 'url(#pattern2)';
                    }
                    else if (data.convertedValue.toString().toLowerCase() === 'false') {
                        ganttSeries.dataColor = '#FFFFFF';
                    }

                    data.convertedValue = i + 1;
                    ganttSeries.data.push(data);
                    lastval = lastval + (data.sampleInterval * 60 * 1000);
                }
            });
            if (ganttSeries.data.length > 0) {
                if (ganttSeries.data.length === 1 && !ganttSeries.data[0].booleanValue) {
                    ganttSeries.data = [];
                }
                ganttDs.push(ganttSeries);
            }
        });
        setGanttDs(ganttDs);
        setGanttAxisMin(ganttAxisMin);
        setBooleanDataSet(booleanDataSet);
        setGanttAxisMax(ganttAxisMax);
    };

    const renderValue = (score, item) => {
        if (score[item.key] === 'true' || score[item.key] === 'True') {
            return true;
        } else if (score[item.key] === 'false' || score[item.key] === 'False') {
            return false;
        } else {
            if (item.key.toLowerCase().includes('sensor')) {
                return score[item.key];
            } else {
                return score[item.key] * 100;
            }
        }
    };

    const getUnitDisplayValue = (rawUnitId) => {
        let targetUnit;
        if (rawUnits) {
            rawUnits.forEach(unit => {
                unit.items.forEach(item => {
                    if (item.id === rawUnitId) {
                        targetUnit = { ...item };
                    }
                });
            });
        }
        return targetUnit ? targetUnit.displayValue : '-';
    };


    const SharedTooltip = (props,parentProps) => {
        const zone = moment.tz.guess();
        const pointDate = props.points[0].category;
        let points = props.points.filter(c => c.series.axis !== 'bottom');
        let booleans = props.points.filter(c => c.series.axis === 'bottom');

        let sensors = [];
        if (props.scoreChartType !== 'Rules' && ganttDs && ganttDs.length > 0) {
            for (var i = 0; i < ganttDs.length; i++) {
                let found = false;
                for (var j = 0; j < booleans.length; j++) {
                    if (ganttDs[i].sensorName === booleans[j].series.name) {
                        found = true;
                        if (sensors.indexOf(ganttDs[i].sensorName) === -1) {
                            sensors.push(ganttDs[i].sensorName);
                            points.push({ dataItem: { booleanValue: booleans[j].series.color === 'url(#pattern2)' ? null: booleans[j].series.color ===  '#FFFFFF' ? false:true }, series: { color: (booleans[j].series.color === '#FFFFFF' || booleans[j].series.color === 'url(#pattern2)') ? '#23c8fa':booleans[j].series.color, axis: 'Boolean', name: ganttDs[i].sensorName } });
                        }
                        break;
                    }
                }
                if (!found && (sensors.indexOf(ganttDs[i].sensorName) === -1)) {
                    sensors.push(ganttDs[i].sensorName);
                    points.push({ dataItem: { booleanValue: false }, series: { color: ganttDs[i].dataColor, axis: 'Boolean', name: ganttDs[i].sensorName } });
                }
            }
        }

        let group = points.reduce((r, a) => {
            if (!a.series.axis) {
                a.series.axis = 'Axis';
            }
            r[a.series.axis] = [...r[a.series.axis] || [], a];
            return r;
        }, {});

        let finalArray = [];
        let booleanobj = null;
        for (var pt in group) {
            if (Object.prototype.hasOwnProperty.call(group, pt) && pt !== 'Boolean') {
                finalArray.push({ axis: pt, points: group[pt].sort((a, b) => { return a.series.name.localeCompare(b.series.name); }) });
            }
            else if (pt === 'Boolean') {
                booleanobj = { axis: pt, points: group[pt].sort((a, b) => { return a.series.name.localeCompare(b.series.name); }) };
            }
        }
        if (booleanobj) {
            finalArray.push(booleanobj);
        }

        const booleanAdjustment = booleanobj ? 30 : 0;
        let marginTop = -40;
        switch (points.length) {
            case 1:
                marginTop = 300 - booleanAdjustment;
                break;
            case 2:
                marginTop = 275 - booleanAdjustment;
                break;
            case 3:
                marginTop = 260 - booleanAdjustment;
                break;
            case 4:
                marginTop = 245 - booleanAdjustment;
                break;
            case 5:
                marginTop = 230 - booleanAdjustment;
                break;
            case 6:
                marginTop = 215 - booleanAdjustment;
                break;
            case 7:
                marginTop = 190 - booleanAdjustment;
                break;
            case 8:
                marginTop = 175 - booleanAdjustment;
                break;
            case 9:
                marginTop = 150 - booleanAdjustment;
                break;
            case 10:
                marginTop = 130 - booleanAdjustment;
                break;
            case 11:
                marginTop = 110 - booleanAdjustment;
                break;
            default:
                marginTop = 300 - booleanAdjustment;
        }
        let root = document.documentElement;
        root.style.setProperty('--sharedTooltipTop', marginTop + 'px');

        const renderItemValue = point => {
            const value = point.dataItem.value;
            if (value === true) {
                return 'True';
            } else if (value === false) {
                return 'False';
            } else if (point.series.isWeather) {
                return parseFloat(value).toFixed(2) + point.series.unit;
            } else {
                return parseFloat(value).toFixed(2) + getUnitDisplayValue(point.series.unit);
            }
        };

        return (
            <div>
                <style>
                    {
                        `
                            .k-chart-shared-tooltip {
                                position: fixed;
                                top: var(--sharedTooltipTop);
                                margin-left: -50px;
                                min-width: auto;
                                padding-bottom: 10px;
                            }
                        `
                    }
                </style>
                <React.Fragment>
                    <div style={{ color: '#000000', fontWeight: 'bold', height: 20, marginBottom: 8 }}>
                        {points && points.length > 0 ? moment(pointDate).format('YYYY-MM-DD h:mm A') + ' ' + getTimeZoneAbbr(moment(pointDate), zone) : ''}
                    </div>
                    {
                        finalArray.map((c, index) =>
                            (<React.Fragment key={index}>
                                {
                                    finalArray && finalArray.length > 1 ?
                                        <div style={{ color: '#464646', fontWeight: 'bold', height: 20, marginTop: 8 }}>
                                            {c.axis}
                                        </div>
                                        :
                                        ''
                                }
                                <React.Fragment>
                                    {
                                        c.points.map((point) => (
                                            <div key={Math.random()} style={{ overflowWrap: 'break-word', height: 20, color: point.series && point.series.color ? point.series.color : '#000000' }}>
                                                {
                                                    point.series.axis === 'Boolean' ?
                                                        <React.Fragment>{point.series.name ?
                                                            <React.Fragment>
                                                                {`${point.series.name} - ${point.dataItem.booleanValue === true ? 'True' : point.dataItem.booleanValue === null ? 'Null':'False' }`}
                                                            </React.Fragment>
                                                            :
                                                            null
                                                        }
                                                        </React.Fragment>
                                                        :
                                                        <React.Fragment>
                                                            <React.Fragment>
                                                                {point.series.name ?
                                                                    <React.Fragment>
                                                                        {`${point.series.name} - `}
                                                                    </React.Fragment>
                                                                    :
                                                                    null
                                                                }
                                                            </React.Fragment>
                                                            <React.Fragment>
                                                                {`${renderItemValue(point)}`}
                                                            </React.Fragment>
                                                        </React.Fragment>
                                                }
                                            </div>
                                        ))
                                    }
                                </React.Fragment>
                            </React.Fragment>
                            ))}
                </React.Fragment>
            </div>
        );
    };

    const SharedTooltipScore = (props) => {
        const zone = moment.tz.guess();
        const pointDate = props.points[0].category;
        let points = props.points.filter(c => c.series.axis !== 'bottom');


        let group = points.reduce((r, a) => {
            if (!a.series.axis) {
                a.series.axis = 'Axis';
            }
            r[a.series.axis] = [...r[a.series.axis] || [], a];
            return r;
        }, {});

        let finalArray = [];
        for (var pt in group) {
            if (Object.prototype.hasOwnProperty.call(group, pt) && pt !== 'Boolean') {
                finalArray.push({ axis: pt, points: group[pt].sort((a, b) => { return a.series.name.localeCompare(b.series.name); }) });
            }
        }

        let marginTop = -40;
        switch (points.length) {
            case 1:
                marginTop = 300;
                break;
            case 2:
                marginTop = 275;
                break;
            case 3:
                marginTop = 260;
                break;
            case 4:
                marginTop = 245;
                break;
            case 5:
                marginTop = 230;
                break;
            case 6:
                marginTop = 215;
                break;
            case 7:
                marginTop = 190;
                break;
            case 8:
                marginTop = 175;
                break;
            case 9:
                marginTop = 150;
                break;
            case 10:
                marginTop = 130;
                break;
            case 11:
                marginTop = 110;
                break;
            default:
                marginTop = 300;
        }
        let root = document.documentElement;
        root.style.setProperty('--sharedTooltipTop', marginTop + 'px');

        const renderItemValue = point => {
            let value = point.dataItem.value;
            if (value === true) {
                return 'True';
            } else if (value === false) {
                return 'False';
            } else if (point.series.isWeather) {
                return parseFloat(value).toFixed(2) + point.series.unit;
            } else {
                value = value !== null && value !== '' ? value.toString().includes('.') ? parseFloat(value).toFixed(2) : value : '';
                return point.series.axis === 'Left Y Axis' ? value + '%' : value + getUnitDisplayValue(point.series.unit);
            }
        };

        return (
            <div>
                <style>
                    {
                        `
                            .k-chart-shared-tooltip {
                                position: fixed;
                                top: var(--sharedTooltipTop);
                                margin-left: -50px;
                                min-width: auto;
                                padding-bottom: 10px;
                            }
                        `
                    }
                </style>
                <React.Fragment>
                    <div style={{color: '#000000', fontWeight: 'bold', height: 20, marginBottom: 8}}>
                        {
                            points && points.length > 0 ?
                                moment(pointDate).format('YYYY-MM-DD h:mm A') + ' ' + getTimeZoneAbbr(moment(pointDate), zone)
                                : ''
                        }
                    </div>
                    {
                        finalArray.map((c, index) => (
                            <React.Fragment key={index}>
                                <React.Fragment>
                                    {
                                        c.points.map((point) => (
                                            <div key={Math.random()} style={{overflowWrap: 'break-word', height: 20, color: point.series && point.series.color ? point.series.color : '#000000'}}>
                                                {
                                                    point.series.axis === 'Boolean' ?
                                                        <React.Fragment>{
                                                            point.series.name ?
                                                                <React.Fragment>{
                                                                    `${ point.series.name } - ${ point.dataItem.booleanValue === true ?
                                                                        'True' : point.dataItem.booleanValue === null ? 'No Data' : 'False' }`
                                                                }
                                                                </React.Fragment>
                                                                : null
                                                        }
                                                        </React.Fragment>
                                                        : <React.Fragment>
                                                            <React.Fragment>
                                                                {
                                                                    point.series.name ?
                                                                        <React.Fragment>
                                                                            {`${ point.series.name } - `}
                                                                        </React.Fragment>
                                                                        : null
                                                                }
                                                            </React.Fragment>
                                                            <React.Fragment>
                                                                {`${ renderItemValue(point) }`}
                                                            </React.Fragment>
                                                        </React.Fragment>
                                                }</div>
                                        ))
                                    }
                                </React.Fragment>
                            </React.Fragment>
                        ))
                    }
                </React.Fragment>
            </div>
        );
    };

    const sharedTooltipRender = (context) => (<SharedTooltip {...context}  />);
    const sharedTooltipRenderScore = (context) => (<SharedTooltipScore {...context}  />);

    const handleClickRule = async dataItem => {
        // configuration changes
        setActiveConfiguration({});
        setSelectedWeatherSensors([]);

        setScores([]);
        let ruleSensors = [];

        let ruleIds = [dataItem.ruleId];

        let currentConfig = ruleScoringConfig;
        let promises = [];

        let weatherSensors = '';
        if (!isEmpty(selectedWeatherSensors)) {
            weatherSensors = activeNavSite.address.postalCode + ':' + selectedWeatherSensors.join(':');
        }

        // This block of code manages the rule config storage
        // We look to see if we have a current configuration
        if (!isEmpty(currentConfig.current)) {

            // If we have a current config we check to see if the current config is the rule selected
            if (ruleScoringConfig.current.ruleId === ruleIds[0]) {

                // If so we just fetch the scoring data from the current configuration
                const rules = ruleScoringConfig.current.ruleId;
                const sensorIds = ruleScoringConfig.current.sensorIds;
                setSelectedRuleSensors(sensorIds);
                ruleIds = sensorIds;

                if (!isEmpty(sensorIds)) {
                    promises.push(fetchEntitySensorData(sensorIds, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { axes, entityId: queryValues.equipment, weatherSensors }));
                } else {
                    clearEntitySensorData();
                }
                promises.push(fetchScoringData(queryValues.company, sensorIds, [rules], dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { EquipmentId: queryValues.equipment, weatherSensors }));

            // We check if the rule selected is one of the previous configurations
            } else if (ruleScoringConfig.previous.find(config => config.ruleId === ruleIds[0])) {

                // If so, we use the sensors from that configuration, set it as the new current, and remove it from the previous array.
                const existingRule = currentConfig.previous.find(config => config.ruleId === ruleIds[0]);
                const currentRule = currentConfig.current;

                currentConfig.previous.push(currentRule);
                currentConfig.previous = currentConfig.previous.filter(item => item.ruleId !== ruleIds[0]);

                currentConfig.current = {
                    ruleId:        ruleIds[0],
                    sensorIds:     existingRule.sensorIds,
                    ruleSensorIds: existingRule.ruleSensorIds
                };
                setSelectedRuleSensors(existingRule.sensorIds);
                setRuleScoringConfiguration(currentConfig);
                ruleSensors = existingRule.sensorIds;

                if (!isEmpty(existingRule.sensorIds)) {
                    promises.push(fetchEntitySensorData(existingRule.sensorIds, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { axes, entityId: queryValues.equipment, weatherSensors }));
                } else {
                    clearEntitySensorData();
                }
                promises.push(fetchScoringData(queryValues.company, existingRule.sensorIds, ruleIds, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { EquipmentId: queryValues.equipment, weatherSensors }));

            // This scenario is what happens when we have a current configuration but select a new rule.
            } else {
                const ids = await fetchSensorIds(queryValues.site, queryValues.equipment, ruleIds);
                setSelectedRuleSensors(ids);
                ruleSensors = ids;

                const currentRule = currentConfig.current;
                currentConfig.previous.push(currentRule);

                currentConfig.current = {
                    ruleId:        ruleIds[0],
                    sensorIds:     ids,
                    ruleSensorIds: ids
                };

                setRuleScoringConfiguration(currentConfig);

                if (!isEmpty(ids)) {
                    promises.push(fetchEntitySensorData(ids, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { axes, entityId: queryValues.equipment, weatherSensors }));
                } else {
                    clearEntitySensorData();
                }
                promises.push(fetchScoringData(queryValues.company, ids, ruleIds, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { EquipmentId: queryValues.equipment, weatherSensors }));
            }

        // This scenario is what happens when there has been no current configuration, initial load.
        } else {
            const ids = await fetchSensorIds(queryValues.site, queryValues.equipment, ruleIds);

            setSelectedRuleSensors(ids);
            ruleSensors = ids;

            currentConfig.current = {
                ruleId:        ruleIds[0],
                sensorIds:     ids,
                ruleSensorIds: ids
            };

            if (!isEmpty(ids)) {
                promises.push(fetchEntitySensorData(ids, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { axes, entityId: queryValues.equipment, weatherSensors }));
            } else {
                clearEntitySensorData();
            }

            promises.push(fetchScoringData(queryValues.company, ids, ruleIds, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { EquipmentId: queryValues.equipment, weatherSensors }));
        }

        let updateConfiguration = cloneDeep(configuration);
        updateConfiguration.selectedRule = dataItem;
        updateConfiguration.selectedSensors = ruleSensors;
        setConfiguration(updateConfiguration);

        setSelectedRule({ ...dataItem, sensorIds: ruleSensors });

        await Promise.all(promises.map(p => p.catch(err => err)));
    };

    const ruleNameCell = props => {
        const { dataItem, field } = props;

        return (
            <td className={dataItem.ruleId === selectedRule.ruleId ? classes.SelectedItem : null}>
                <span
                    className={classes.RuleName}
                    onClick={() => handleClickRule(dataItem)}
                    role="none"
                    onKeyDown={() => handleClickRule(dataItem)}
                >
                    {dataItem[field]}
                </span>
            </td>
        );
    };

    const ruleScoreCell = props => {
        const { field } = props;
        let value = props.dataItem[field];
        value = value !== null && value !== '' ? value.toString().includes('.') ? parseFloat(value).toFixed(2) : value : '';
        const colorClass = value === null ? classes.noColor : value > 74 ? classes.Green : value > 49 ? classes.Yellow : value >= 0 ? classes.Red : classes.NoColor;
        return (
            <td className={clsx(props.className, colorClass)} style={props.style}>
                {value}
            </td>
        );
    };

    const renderAxisCrossingValue = () => {
        let axisCrossingValue = [];

        if (!isEmpty(scores)) {
            if (!scores[0].axis) {
                return [];
            }
        }

        scores.map(item =>
            axisCrossingValue.push(new Date(moment(dashboardEndTimeStamp).add(1, 'days')))
        );

        axisCrossingValue.pop();
        axisCrossingValue.push(0);

        return axisCrossingValue.reverse();
    };

    const renderAxisCrossingSensorValue = () => {
        let axisCrossingValue = [];

        if (!isEmpty(numericSensors)) {
            if (!numericSensors[0].axis) {
                return [];
            }
        }

        numericSensors.map(item =>
            axisCrossingValue.push(new Date(moment(dashboardEndTimeStamp).add(1, 'days')))
        );

        axisCrossingValue.pop();
        axisCrossingValue.push(0);

        return axisCrossingValue.reverse();
    };

    const onGridDataStateChange = e => {
        setGridDataState(e.dataState);
    };

    const onRuleGridRowClick = e => {
        handleClickRule(e.dataItem);
    };

    const clearGridFilter = filter => {
        setGridDataState({...gridDataState, filter: filter ? filter : initialDataStateFilter});
    };

    if (!isActive) return null;

    return (
        <div className={classes.ScoresPanel}>
            <div style={{position: 'absolute',width: 0,height: 0}}>
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
                    <defs>
                        <pattern
                            id="pattern2" width="3" height="3"
                            patternTransform="rotate(45 0 0)" patternUnits="userSpaceOnUse"
                        >
                            <line
                                x1="0" y1="0" x2="0"
                                y2="10" style={{stroke: '#8d8d8d',strokeWidth: 1}}
                            />
                        </pattern>
                    </defs>
                </svg>
            </div>
            <div className={classes.TableContainer}>
                <style>
                    { kendoGridInlineStyling }
                    {
                        `.k-toolbar {
                             order: 1;
                             border-top: inset 1px rgba(0, 0, 0, 0.12);
                             max-height: 5.8rem;
                        }`
                    }
                </style>
                <Grid
                    sortable={true}
                    className={classes.KendoGrid}
                    filterable={workbookModeEnabled}
                    data={kendoProcess(ruleScoreKpis, gridDataState)}
                    {...gridDataState}
                    onDataStateChange={onGridDataStateChange }
                    onRowClick={onRuleGridRowClick}
                >
                    {
                        workbookModeEnabled ?
                            <GridToolbar>
                                <FilterPanel
                                    title={'Rule Filter Builder'}
                                    filter={gridDataState.filter}
                                    filterText={gridFilterText}
                                    fields={gridFields}
                                    columns={[{name: 'Rule', field: 'ruleName', filter: 'text'}, {name: 'Score', field: 'score', filter: 'numeric'}]}
                                    setFilter={clearGridFilter}
                                    setFilterText={setGridFilterText}
                                />
                            </GridToolbar>
                            : null
                    }
                    {
                        bobLoading.includes('RuleKpi') ?
                            <GridNoRecords>
                                Loading rules
                            </GridNoRecords>
                            :
                            null
                    }
                    <Column
                        field="ruleName"
                        key="ruleId"
                        title="Rule"
                        cell={ruleNameCell}
                        filter={'text'}
                    />
                    <Column
                        field="score"
                        key="score"
                        title="Score"
                        cell={ruleScoreCell}
                        filter={'numeric'}
                    />
                </Grid>
                {
                    isEmpty(selectedRule) ?
                        <NoSelectedSensorsScreen
                            style={{
                                width:      '80%',
                                margin:     '0',
                                marginLeft: '1rem'
                            }}
                            message="Please select a Rule from the panel to the left or the dropdown list above to load the data"
                            height={scoreGraphHeight}
                        />
                        :
                        <React.Fragment>
                            {props.scoreChartType === 'Rules'?
                                <React.Fragment>
                                    <Chart
                                        style={{
                                            height:     scoreGraphHeight,
                                            marginLeft: '1rem',
                                            width:      '80%'
                                        }}
                                        key="Chart-1"
                                        ref={chart}
                                        pannable={{ lock: 'y' }}
                                        zoomable={{ mousewheel: { lock: 'y' }, selection: { lock: 'y' } }}
                                    >
                                        <ChartTitle text={`${selectedRule.ruleName} - Score`} align="left" font="12pt sans-serif" />
                                        <ChartTooltip
                                            shared={true} render={sharedTooltipRenderScore} background="#FFFFFF"
                                            opacity={.95}
                                        />

                                        <ChartCategoryAxis>
                                            <ChartCategoryAxisItem
                                                baseUnit="minutes"
                                                baseUnitStep={15}
                                                pane="top"
                                                maxDivisions={12}
                                                labels={{ visible: true}}
                                                axisCrossingValue={renderAxisCrossingValue()}
                                            />
                                        </ChartCategoryAxis>
                                        <ChartLegend position="top" orientation="horizontal"  visible={true} />
                                        <ChartSeries>
                                            {scores.map((item, index) => (
                                                <ChartSeriesItem
                                                    axis={item.axis}
                                                    markers={{ visible: false }}
                                                    type={props.chartType === 'Line' ? 'line' : 'column'}
                                                    categoryField="timestamp"
                                                    name={item.name}
                                                    key={index}
                                                    data={item.data}
                                                    field="value"
                                                    unit={item.unit}
                                                    // eslint-disable-next-line react/style-prop-object
                                                    style="smooth"
                                                />
                                            ))}
                                        </ChartSeries>
                                        <ChartValueAxis>
                                            <ChartValueAxisItem
                                                key={0}
                                                name={'Left Y Axis'}
                                                title={{ text: 'Score' }}
                                                narrowRange={true}
                                                majorGridLines={
                                                    { width: 1, dashType: 'dot' }
                                                }
                                            />
                                        </ChartValueAxis>
                                    </Chart>
                                </React.Fragment>:
                                <React.Fragment>
                                    <Chart
                                        style={{
                                            height:     scoreGraphHeight,
                                            marginLeft: '1rem',
                                            width:      '80%'
                                        }}
                                        key="Chart-2"
                                        ref={chart}
                                        pannable={{ lock: 'y' }}
                                        zoomable={{ mousewheel: { lock: 'y' }, selection: { lock: 'y' } }}
                                    >
                                        <ChartTitle text="Sensors" align="left" font="12pt sans-serif" />
                                        <ChartTooltip
                                            shared={true} visible = {true} render={sharedTooltipRender}
                                            background="#FFFFFF"
                                            opacity={.95}
                                        />
                                        {
                                            !isEmpty(ganttDs) && props.scoreChartType !== 'Rules' ?
                                                <ChartPanes>
                                                    <ChartPane name="top" />
                                                    <ChartPane name="bottom" />
                                                </ChartPanes>
                                                :
                                                <ChartPanes>
                                                    <ChartPane name="top" />
                                                </ChartPanes>
                                        }
                                        {
                                            !isEmpty(ganttDs) && props.scoreChartType !== 'Rules'?
                                                <ChartCategoryAxis>
                                                    <ChartCategoryAxisItem
                                                        baseUnit="minutes"
                                                        baseUnitStep={15}
                                                        pane="top"
                                                        maxDivisions={12}
                                                        labels={{ visible: isEmpty(ganttDs) ? true : false }}
                                                        axisCrossingValue={renderAxisCrossingSensorValue()}
                                                    />
                                                    <ChartCategoryAxisItem
                                                        baseUnit="minutes"
                                                        baseUnitStep={15}
                                                        pane="bottom"
                                                        maxDivisions={12}
                                                    />
                                                </ChartCategoryAxis>
                                                :
                                                <ChartCategoryAxis>
                                                    <ChartCategoryAxisItem
                                                        baseUnit="minutes"
                                                        baseUnitStep={15}
                                                        pane="top"
                                                        maxDivisions={12}
                                                        labels={{ visible: isEmpty(ganttDs) ? true : false }}
                                                        axisCrossingValue={renderAxisCrossingSensorValue()}
                                                    />
                                                </ChartCategoryAxis>
                                        }
                                        <ChartLegend position="top" orientation="horizontal"  visible={true} />
                                        <ChartSeries>
                                            {numericSensors.map((item, index) => (
                                                <ChartSeriesItem
                                                    axis={item.axis}
                                                    markers={{ visible: false }}
                                                    type={props.chartType === 'Line' ? 'line' : 'column'}
                                                    categoryField="timestamp"
                                                    name={item.name}
                                                    key={index}
                                                    data={item.data}
                                                    field="value"
                                                    unit={item.unit}
                                                    isWeather={item.isWeather}
                                                    // eslint-disable-next-line react/style-prop-object
                                                    style="smooth"
                                                />
                                            ))}
                                            {ganttDs.map((item, i) => (
                                                <ChartSeriesItem
                                                    axis={'bottom'}
                                                    markers={{ visible: (item.dataColor === '#ff6d01' || item.dataColor === '#6f6f6f') ?true:false, size: 4, background: `${item.dataColor}`}}
                                                    type="line"
                                                    width={6}
                                                    categoryField="timestamp"
                                                    name={item.sensorName}
                                                    key={`${item.sensorId}-${i}`}
                                                    visibleInLegend={false}
                                                    color={item.dataColor}
                                                    data={item.data}
                                                    field="convertedValue"
                                                />
                                            ))}
                                        </ChartSeries>
                                        <ChartValueAxis>
                                            <ChartValueAxisItem
                                                key={0}
                                                name={'Left Y Axis'}
                                                title={{ text: 'Sensors' }}
                                                narrowRange={true}
                                                majorGridLines={
                                                    { width: 1, dashType: 'dot' }
                                                }
                                            />
                                            <ChartValueAxisItem
                                                key={999}
                                                name="bottom"
                                                pane="bottom"
                                                line={{ visible: true }}
                                                majorGridLines={
                                                    { width: 1, dashType: 'dot' }
                                                }
                                                min={ganttAxisMin}
                                                majorUnit={1}
                                                max={ganttAxisMax}
                                                labels={{ content: labelContent, visible: true }}
                                            />
                                        </ChartValueAxis>
                                    </Chart> </React.Fragment>}
                        </React.Fragment>
                }
                {
                    bobLoading.includes('ScoreData') || bobLoading.includes('SensorIds') || bobLoading.includes('RuleKpi') ?
                        <BobLoadingMask />
                        :
                        null
                }
            </div>
        </div>
    );
};

ScoresPanel.defaultProps = {
    clearEntityScoresData: () => { },
    entityScoresData:      [],
    isActive:              false
};

ScoresPanel.propTypes = {
    clearEntityScoresData: func,
    entityScoresData:      array,
    isActive:              bool
};

const mapStateToProps = state => {
    return {
        activeNavSite:           state.bob.activeNavSite,
        bobLoading:              state.bob.bobLoading,
        dashboardEndTimeStamp:   state.dashboard.dashboardEndTimeStamp,
        dashboardStartTimeStamp: state.dashboard.dashboardStartTimeStamp,
        desiredInterval:         state.dashboard.desiredInterval,
        entityScoringData:       state.bob.entityScoringData,
        entityScoresData:        state.bob.entityScoresData,
        rawUnits:                state.architect.rawUnits,
        ruleScoreKpis:           state.dashboard.ruleScoreKpis,
        ruleScoringConfig:       state.dashboard.ruleScoringConfig,
        selectedRule:            state.dashboard.selectedRule,
        selectedWeatherSensors:  state.dashboard.selectedWeatherSensors,
        allSensors:              state.bob.allSensors,
        workbookModeEnabled:     state.dashboard.workbookModeEnabled
    };
};

const mapDispatchToProps = {
    ...BobActions,
    ...ConfigurationActions,
    ...DashboardActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ScoresPanel));
